let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("exGqx")).then(() => parcelRequire('5q8CD'));